
export const userLogado = localStorage.getItem("nomeFuncionario") !== "undefined" && localStorage.getItem("nomeFuncionario") !== null

const userAccess = localStorage.getItem("permissoesFuncionario") !== null? localStorage.getItem("permissoesFuncionario").split(/[,]+/) : []

export function userHasAccess(access) { return userAccess.includes(access) }

export function userData()
{
    if (!userLogado) { return {} }

    return {
        nome: localStorage.getItem("nomeFuncionario"),
        matricula: localStorage.getItem("matriculaFuncionario"),
        funcao: localStorage.getItem("cargoFuncionario"),
        permissoes: userAccess,
        token: localStorage.getItem("token"),
        tokenType: localStorage.getItem("tokenType")
    }
}

export function updateUserData(newData)
{
    if (newData === undefined || newData === null) { return }

    const permissoes = []
    for (let acesso of newData.roles)
    {
        permissoes.push(acesso.name)
    }

    if (newData.nome !== undefined && newData.nome !== null)   
        localStorage.setItem("nomeFuncionario", newData.nome)    
    if (newData.matricula !== undefined && newData.matricula !== null)
        localStorage.setItem("matriculaFuncionario", newData.matricula)
    if (newData.cargo !== undefined && newData.cargo !== null)
        localStorage.setItem("cargoFuncionario", newData.cargo)
    if (newData.roles !== undefined && newData.roles !== null)
        localStorage.setItem("permissoesFuncionario", permissoes)
    
}

export function registerUser(newData)
{
    if (newData === undefined || newData === null) { return }

    updateUserData(newData.func)

    if (newData.accessToken !== undefined && newData.accessToken !== null)
        localStorage.setItem("token", newData.accessToken)
    if (newData.tokenType !== undefined && newData.tokenType !== null)
        localStorage.setItem("tokenType", newData.tokenType)
    
}